import { render, staticRenderFns } from "./UnauthLefSection.vue?vue&type=template&id=53f3aa7d&scoped=true"
import script from "./UnauthLefSection.vue?vue&type=script&lang=js"
export * from "./UnauthLefSection.vue?vue&type=script&lang=js"
import style0 from "./UnauthLefSection.vue?vue&type=style&index=0&id=53f3aa7d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f3aa7d",
  null
  
)

export default component.exports